/** A short draw-on reveal, overlapping a smooth pull back to the fitted board. */
export const ENTRANCE_DURATION = 1450;
const clamp = (value: number) => Math.max(0, Math.min(1, value));
const smooth = (value: number) => { const t = clamp(value); return t * t * (3 - 2 * t); };

export function entranceZoom(elapsed: number): number {
  return 1 + 1.15 * (1 - smooth((elapsed - 140) / 1160));
}

export function entranceReveal(elapsed: number, delay: number): number {
  const t = clamp((elapsed - delay) / 580);
  return 1 - (1 - t) ** 3;
}

/** Spatial staggering keeps the reveal coherent regardless of arrow/solve order. */
export function entranceDelay(x: number, y: number, width: number, height: number): number {
  return 180 * clamp((x / Math.max(1, width) + y / Math.max(1, height)) / 2);
}
